import { render, staticRenderFns } from "./editProject.vue?vue&type=template&id=77fe5180&"
import script from "./editProject.vue?vue&type=script&lang=js&"
export * from "./editProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports